import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";

const { smaller, greaterOrEqual, smallerOrEqual, isGreater, isSmaller } = useBreakpoints(breakpointsTailwind);

const isMobile = smaller("md");
const isDesktop = greaterOrEqual("md");
const isLargeDesktop = greaterOrEqual("lg");

export { greaterOrEqual, isDesktop, isGreater, isLargeDesktop, isMobile, isSmaller, smallerOrEqual, smaller as smallerThan };
